import clsx from 'clsx';
import React from 'react';
import * as styles from './Title.module.scss';

export default function Title({className, children}) {
  return (
    <section className={clsx(styles.title, className)}>{ children }</section>
  )
}